import { useAppBuilderContext } from 'app/app/editor/context';
import moment from 'moment';
import { IHistoryRecord } from 'app/app/editor/useHistory';
import { Box, alpha, Stack } from '@mui/material';
import { useEffect } from 'react';

export default function HistoryTab() {
    const ctx = useAppBuilderContext();

    const onRecordSelect = (time: number) => {
        const record = ctx.history.historyList.find((r) => r.date.getTime() == time);
        if (!record) {
            return;
        }
        ctx.history.selectHistoryRecord(time);
        ctx.sendMessage({ name: 'showHistory', data: record });
    };

    useEffect(() => {
        return () => {
            ctx.history.selectHistoryRecord(0);
            ctx.sendMessage({ name: 'showHistory', data: null });
        };
    }, []);

    return (
        <Stack height={1}>
            <Stack sx={{ p: 2, flexGrow: 1, overflow: 'auto' }} spacing={0.5}>
                {([] as Array<IHistoryRecord>)
                    .concat(ctx.history.historyList)
                    .reverse()
                    .map((h) => {
                        const time = h.date.getTime();
                        const isSelected = time == ctx.history.selectedHistoryRecord;
                        return (
                            <Box
                                key={time}
                                onClick={() => onRecordSelect(time)}
                                sx={{
                                    border: '1px solid',
                                    borderColor: (theme) =>
                                        isSelected
                                            ? theme.palette.success.main
                                            : alpha(theme.palette.text.primary, 0.08),
                                    borderRadius: '8px',
                                    backgroundColor: isSelected
                                        ? (theme) => alpha(theme.palette.primary.main, 0.08)
                                        : undefined,
                                    p: 1.5,
                                    '&:hover': {
                                        backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
                                        borderColor: isSelected ? (theme) => theme.palette.success.main : 'transparent',
                                        cursor: 'pointer',
                                    },
                                }}
                            >
                                <Box sx={{ fontWeight: 600 }}>{moment(h.date).format('MMMM DD, hh:mm:ss')}</Box>
                                <Box>{h.author}</Box>
                            </Box>
                        );
                    })}
            </Stack>
        </Stack>
    );
}
